<template>
  <el-dialog title="应急处理事件进展详情" :visible.sync="open" width="800px" append-to-body>
    <el-descriptions :column="2" border>
      <el-descriptions-item label="项目">
        {{ detail.project }}
      </el-descriptions-item>
      <el-descriptions-item label="产生时间">
        {{ detail.occurrenceTime }}
      </el-descriptions-item>
      <el-descriptions-item label="反应时长">
        <el-tag :type="getDurationTagType(detail.responseDuration)">
          {{ detail.responseDuration }} 分钟
        </el-tag>
      </el-descriptions-item>
      <el-descriptions-item label="责任人">
        {{ detail.responsiblePerson }}
      </el-descriptions-item>
      <el-descriptions-item label="创建人">
        {{ detail.createByUserName }}
      </el-descriptions-item>
      <el-descriptions-item label="创建时间">
        {{ detail.createTime }}
      </el-descriptions-item>
      <el-descriptions-item label="更新人">
        {{ detail.updateByUserName }}
      </el-descriptions-item>
      <el-descriptions-item label="更新时间">
        {{ detail.updateTime }}
      </el-descriptions-item>
      <el-descriptions-item label="事件内容" :span="2">
        <div style="white-space: pre-wrap; word-break: break-all; max-height: 300px; overflow-y: auto;">
          {{ detail.incidentContent }}
        </div>
      </el-descriptions-item>
    </el-descriptions>
    
    <div slot="footer" class="dialog-footer">
      <el-button @click="open = false">关闭</el-button>
    </div>
  </el-dialog>
</template>

<script>
import {queryEmergencyIncidentDetail} from "@/api/crm/emergencyIncident";

export default {
  name: "EmergencyIncidentDetailDialog",
  data() {
    return {
      // 是否显示弹出层
      open: false,
      // 详情数据
      detail: {}
    };
  },
  methods: {
    // 打开对话框
    open(id) {
      this.open = true;
      this.detail = {};
      this.getDetail(id);
    },
    
    // 获取详情
    getDetail(id) {
      queryEmergencyIncidentDetail({id}).then(response => {
        this.detail = response.data || {};
      });
    },
    
    /** 根据反应时长获取标签类型 */
    getDurationTagType(duration) {
      if (duration <= 30) return 'success';
      if (duration <= 60) return 'warning';
      return 'danger';
    }
  }
};
</script>